import React from "react";
import { useLocale } from "hooks";
import { useCurrencyCode } from "hooks/useCurrencyCode";
import { formatCurrency } from "@membership/member-benefits";
import {
  cardWrapper,
  titleWrapper,
  description
} from "./BenefitsSavingsCard.css";

type Props = {
  title: string;
  value: number;
};

export const BenefitsSavingsCard: React.FC<Props> = ({ title, value }) => {
  const currencyCode = useCurrencyCode();
  const locale = useLocale();

  return (
    <div className={cardWrapper}>
      <p className={titleWrapper}>{title}</p>
      <p className={description}>
        {formatCurrency(value, locale, currencyCode)}
      </p>
    </div>
  );
};
